// // import React, { useState } from 'react';
// // import axios from 'axios';
// // import logo_gameit from "../Media/Documentation/assets/img/logo_gameit.png";

// // const Subscribe = () => {
// //   const [loading, setLoading] = useState(false);

// // const handleSubscribe = async () => {
// //   try {
// //     const urlParams = new URLSearchParams(window.location.search);
// //     let extRef = urlParams.get("ext_ref");

// //     // Generate one if missing
// //     if (!extRef) {
// //       extRef = generateExtRef(); // fallback ID
// //       console.log("Generated ext_ref:", extRef);
// //     }

// //     setLoading(true);

// //     const response = await axios.get(`/generatelink?extRef=${extRef}`);
// //     console.log("Redirecting to:", response.data.consentGatewayURL);

// //     // Use faster redirect method
// //     window.location.assign(response.data.consentGatewayURL);
// //   } catch (error) {
// //     console.error("Subscription failed", error);
// //     alert("Subscription failed. Please try again.");
// //   } finally {
// //     setLoading(false);
// //   }
// // };


// // const generateExtRef = () => {
// //   return [...Array(32)]
// //     .map(() => Math.floor(Math.random() * 16).toString(16))
// //     .join('');
// // };



// //   // const handleSubscribe = async () => {
// //   //   try {
// //   //     const urlParams = new URLSearchParams(window.location.search);
// //   //     const extRef = urlParams.get("ext_ref");
// //   //     console.log("EXT_REF",extRef)
// //   //     const response = await axios.get(`/generatelink?extRef=${extRef}`);
// //   //     console.log("Redirecting to:", response.data.consentGatewayURL);
      
// //   //     // Use faster redirect method
// //   //     window.location.assign(response.data.consentGatewayURL);
// //   //   } catch (error) {
// //   //     console.error("Subscription failed", error);
// //   //     alert("Subscription failed. Please try again.");
// //   //   }
// //   // };
  
// //   return (
// //     <div className='flex py-12 px-5 md:px-0 justify-center bg-[#1F1329] items-center h-screen'>
// //       <div className="max-w-lg bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
// //         <a href="#" className='flex justify-center py-3'>
// //           <img className="rounded-t-lg w-auto h-20" src={logo_gameit} alt="Game Station Logo" />
// //         </a>
// //         <div className="p-4 text-center">
// //           <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-900">
// //             🎮 እንኳን ወደ Game Station በደህና መጡ! 🚀
// //           </h5>
// //           <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
// //            በ2 ብር ብቻ ፤ በእለታዊ ያልተገደቡ ጨዋታዎች ይደሰቱ! ልዩ ልዩ ጨዋታዎችንም ያግኙ!!
// //           </p>

// //           <button 
// //             onClick={handleSubscribe}
// //             className={`inline-flex items-center px-4 py-2 text-sm font-medium text-white rounded-lg 
// //               ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"}
// //               focus:ring-4 focus:outline-none focus:ring-green-300 dark:bg-green-500 dark:hover:bg-green-600 dark:focus:ring-green-700`
// //             }
// //             disabled={loading}
// //           >
// //             {loading ? "Redirecting..." : " ይመዝገቡ"}
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // export default Subscribe;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const Subscribe = () => {
//   const [loading, setLoading] = useState(false);

//   const handleSubscribe = async () => {
//     try {
//       const urlParams = new URLSearchParams(window.location.search);
//       let extRef = urlParams.get("ext_ref");

//       if (!extRef) {
//         extRef = generateExtRef();
//         console.log("Generated ext_ref:", extRef);
//       }

//       setLoading(true);
//       const response = await axios.get(`/generatelink?extRef=${extRef}`);
//       console.log("Redirecting to:", response.data.consentGatewayURL);
//       window.location.assign(response.data.consentGatewayURL);
//     } catch (error) {
//       console.error("Subscription failed", error);
//       alert("Subscription failed. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const generateExtRef = () => {
//     return [...Array(32)]
//       .map(() => Math.floor(Math.random() * 16).toString(16))
//       .join('');
//   };


//   return (
//     <div className="min-h-screen w-full bg-black overflow-y-auto">
//       <div
//         // className="min-h-screen w-full bg-contain bg-center bg-no-repeat flex flex-col items-center justify-center p-5 sm:p-7"
//           className="min-h-screen w-full bg-cover md:bg-contain bg-center bg-no-repeat flex flex-col items-center justify-center p-5 sm:p-7"
//   style={{ backgroundImage: "url('/bg.png')" }}
//         // style={{ backgroundImage: "url('/bg.png')" }}
//       >
//         {/* Title */}
//         <div className="text-center text-white font-extrabold text-4xl sm:text-5xl drop-shadow-md tracking-wide mb-3">
//           <span className="block">GAME</span>
//           <span className="block">STATION</span>
//         </div>

//         {/* Subtext */}
//         <p className="text-white text-center text-sm sm:text-lg font-semibold mb-4 px-2">
//           አዲሱን በመጫወት ለጊዜ ነፃ ይደሰቱ!
//         </p>

//         {/* Phone UI */}
//         <div className="w-52 max-w-full h-auto rounded-[2rem] border-[6px] border-gray-300 overflow-hidden shadow-2xl mb-4 bg-black flex items-center justify-center">
//           <img
//             src="/gameimg.png"
//             alt="Game UI"
//             className="w-full h-auto object-contain"
//           />
//         </div>

//         {/* Subscription Instructions */}
//         <p className="text-white text-xs sm:text-sm text-center max-w-md mb-3 px-4 leading-snug">
//           እባክዎ ሲመዝገቡ መረጃዎ ከ 2 ቢል ብቻ በኋላ በማታወቅ ጨዋታዎች ይደሰቱ። እንዲያቆሙ ማስታወቂያ መልክት ወደ 9356 stop ብለው ይላኩ።
//         </p>

//         {/* Subscribe Button */}
//         <button
//           onClick={handleSubscribe}
//           className={`text-yellow-400 font-extrabold text-xl bg-yellow-500 hover:bg-yellow-600 px-6 py-2 rounded-lg shadow transition duration-300 ${
//             loading ? "opacity-50 cursor-not-allowed" : ""
//           }`}
//           disabled={loading}
//         >
//           {loading ? "Redirecting..." : "ስብስክራይብ"}
//         </button>

//         {/* Contact */}
//         <p className="text-white text-sm mt-4 text-center px-4">
//           ለተጨማሪ መረጃ ይደውሉ፡ <span className="font-bold">+251116721313 ደውልልኝ</span>
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Subscribe;


import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Subscribe = () => {
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      let extRef = urlParams.get("ext_ref");

      if (!extRef) {
        extRef = generateExtRef();
        console.log("Generated ext_ref:", extRef);
      }

      setLoading(true);
      const response = await axios.get(`/generatelink?extRef=${extRef}`);
      console.log("Redirecting to:", response.data.consentGatewayURL);
      window.location.assign(response.data.consentGatewayURL);
    } catch (error) {
      console.error("Subscription failed", error);
      alert("Subscription failed. Please try again.");
    } finally {
      setLoading(true);
    }
  };

  const generateExtRef = () => {
    return [...Array(32)]
      .map(() => Math.floor(Math.random() * 16).toString(16))
      .join('');
  };

  return (
    <div className="min-h-screen w-full bg-gray-300 overflow-y-auto">
      <div 
      // className="min-h-screen w-full bg-cover bg-center bg-no-repeat flex flex-col items-center justify-center p-5 sm:p-7" 
      // style={{ backgroundImage: "url('/bg.png')" }}
      className="min-h-screen w-full bg-cover md:bg-contain bg-center bg-no-repeat flex flex-col items-center justify-center p-5 sm:p-7 "
        style={{ backgroundImage: "url('/bgwhite.png')" }}
      >

        {/* Title */}
       {/* <div className="text-center font-bebas text-4xl sm:text-5xl text-gray-800 drop-shadow-md tracking-wide mb-1">
          <span className="block">GAME</span>
          <span className="block">STATION</span>
        </div> */}
        <div className="text-center font-bebas text-gray-100 text-5xl sm:text-6xl drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)] tracking-wider mb-2">
  <span className="block">GAME</span>
  <span className="block">STATION</span>
</div>


        {/* Subtext */}
        <p className="text-center font-bebas tracking-wider text-base sm:text-2xl font-bold mb-3 text-black">
          GET <span className="text-blue-700">3 DAYS FREE</span> BY SUBSCRIBING TODAY!
        </p>
            
             
        {/* Phone UI */}
        <div className="w-60 max-w-full rounded-[2rem] border-[6px]  overflow-hidden shadow-2xl mb-5 bg-white flex items-center justify-center">
          <img
            src="/newgamebg.png"
            alt="Game UI"
            className="w-full h-auto object-contain"
          />
        </div>

       

        {/* Subscription Details */}
        <p className="text-center text-black font-semibold font-bebas tracking-wider text-xl px-5 max-w-md leading-relaxed mb-4">
          SUBSCRIBE NOW, AND PLAY UNLIMITED GAMES WITH ONLY 2 BIRR/DAY. TO SUBSCRIBE SEND STOP TO 9356.
        </p>

        {/* Subscribe Button */}
        <button
          onClick={handleSubscribe}
          className={`text-white font-bold text-lg bg-blue-700 hover:bg-blue-800 px-6 py-2 rounded-lg shadow transition duration-300 ${
            loading ? "opacity-50 cursor-not-allowed" : ""
          }`}
          disabled={loading}
        >
          {loading ? "Redirecting..." : "SUBSCRIBE"}
        </button>

        {/* Contact Info */}
        <p className="text-black font-bold font-bebas tracking-wider text-xl mt-4 text-center px-4">
      FOR HELP DESK, PLEASE CONTACT US <span className="text-blue-800 font-bold">+251116721313</span>
        </p>
      </div>
    </div>
  );
};

export default Subscribe;
